import FlexLayout from "../../controls/FlexLayout";
import FormInput from "../../controls/FormInput";
import Icon from "../../controls/Icon";
import Modal from "../../controls/Modal";
import Spinner from "../../controls/Spinner";
import { IconButton } from "../../controls/TooltipControls";
import ZoomableImage from "../../controls/ZoomableImage";
import { NEXUS_BASE_URL } from "../nexus_integration/constants";
import bbcode from "../../controls/bbcode";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import opn from "../../util/opn";
import { largeNumToString } from "../../util/util";
import { downloadAndInstallExtension, selectorMatch } from "./util";
import * as React from "react";
import { Button, FormControl, ListGroup, ListGroupItem, ModalHeader, } from "react-bootstrap";
import * as semver from "semver";
import { getApplication } from "../../util/application";
const NEXUS_MODS_URL = `${NEXUS_BASE_URL}/site/mods/`;
const GITHUB_BASE_URL = "https://www.github.com";
function makeSelectorId(ext) {
    if (ext.modId !== undefined) {
        return `${ext.modId}`;
    }
    else {
        return `${ext.github}/${ext.githubRawPath}`;
    }
}
const version = (() => {
    let result;
    return () => {
        if (result === undefined) {
            result = getApplication().version;
        }
        return result;
    };
})();
function nop() {
    // nop
}
class BrowseExtensions extends ComponentEx {
    mModalRef;
    constructor(props) {
        super(props);
        this.initState({
            error: undefined,
            selected: undefined,
            installing: [],
            searchTerm: "",
            sort: "name",
        });
        this.mModalRef = React.createRef();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.localState.preselectModId !==
            this.props.localState.preselectModId &&
            nextProps.localState.preselectModId !== undefined) {
            this.nextState.selected = {
                modId: nextProps.localState.preselectModId,
                github: undefined,
                githubRawPath: undefined,
            };
        }
    }
    render() {
        const { t, availableExtensions, language, onHide, onRefreshExtensions, updateTime, visible, } = this.props;
        const { searchTerm, selected, sort } = this.state;
        const ext = selected === undefined
            ? null
            : availableExtensions.find((iter) => selectorMatch(iter, selected));
        const updatedAt = new Date(updateTime);
        return (React.createElement(Modal, { id: "browse-extensions-dialog", show: visible, onHide: nop, ref: this.mModalRef },
            React.createElement(ModalHeader, null,
                React.createElement("h3", null, t("Browse Extensions"))),
            React.createElement(Modal.Body, null,
                React.createElement(FlexLayout, { type: "row" },
                    React.createElement(FlexLayout.Fixed, { className: "extension-list" },
                        React.createElement(FlexLayout, { type: "column" },
                            React.createElement(FlexLayout.Fixed, null,
                                React.createElement(FormInput, { id: "browse-extensions-search", label: t("Search"), placeholder: t("Search"), value: searchTerm, onChange: this.changeSearch, debounceTimer: 200 })),
                            React.createElement(FlexLayout.Fixed, null,
                                React.createElement(FlexLayout, { type: "row", className: "extension-sort-container" },
                                    React.createElement(FlexLayout.Fixed, null, t("Sort by")),
                                    React.createElement(FlexLayout.Flex, null,
                                        React.createElement(FormControl, { componentClass: "select", onChange: this.changeSort, value: sort },
                                            React.createElement("option", { key: "name", value: "name" }, t("Name")),
                                            React.createElement("option", { key: "endorsements", value: "endorsements" }, t("Endorsements")),
                                            React.createElement("option", { key: "downloads", value: "downloads" }, t("Downloads")),
                                            React.createElement("option", { key: "recent", value: "recent" }, t("Last update")))))),
                            React.createElement(FlexLayout.Flex, null,
                                React.createElement(ListGroup, { style: { height: "100%" } }, availableExtensions
                                    .filter(this.filterSearch)
                                    .sort(this.extensionSort)
                                    .map(this.renderListEntry))),
                            React.createElement(FlexLayout.Fixed, null,
                                React.createElement("div", { className: "extension-list-time" },
                                    t("Last updated: {{time}}", {
                                        replace: { time: updatedAt.toLocaleString(language) },
                                    }),
                                    React.createElement(IconButton, { icon: "refresh", tooltip: t("Refresh"), onClick: onRefreshExtensions }))))),
                    React.createElement(FlexLayout.Flex, { fill: true }, ext === null ? null : this.renderDescription(ext)))),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { onClick: onHide }, t("Close")))));
    }
    changeSearch = (newValue) => {
        this.nextState.searchTerm = newValue ?? "";
    };
    changeSort = (evt) => {
        const target = evt.target;
        this.nextState.sort = target.value;
    };
    filterSearch = (test) => {
        const { searchTerm } = this.state;
        if (test.hide) {
            return false;
        }
        if (!searchTerm) {
            return true;
        }
        const searchTermNorm = searchTerm.toUpperCase();
        return (test.name?.toUpperCase?.().indexOf?.(searchTermNorm) !== -1 ||
            test.author?.toUpperCase?.().indexOf?.(searchTermNorm) !== -1 ||
            test.description?.short?.toUpperCase?.().indexOf?.(searchTermNorm) !==
                -1 ||
            test.description?.long?.toUpperCase?.().indexOf?.(searchTermNorm) !== -1);
    };
    extensionSort = (lhs, rhs) => {
        switch (this.state.sort) {
            case "downloads":
                return (rhs.downloads || 0) - (lhs.downloads || 0);
            case "endorsements":
                return (rhs.endorsements || 0) - (lhs.endorsements || 0);
            case "recent":
                return (rhs.timestamp || 0) - (lhs.timestamp || 0);
            default:
                return lhs.name.localeCompare(rhs.name);
        }
    };
    isCompatible(ext) {
        if (ext.dependencies === undefined ||
            ext.dependencies["vortex"] === undefined ||
            process.env.NODE_ENV === "development") {
            return true;
        }
        return semver.satisfies(version(), ext.dependencies["vortex"], {
            includePrerelease: true,
        });
    }
    isInstalled(ext) {
        const { extensions } = this.props;
        return (Object.keys(extensions)
            // looking at modid for mods hosted on nexus and the id for games in vortex-games.
            // In the past we used the name for games from the repo but that meant that the games
            // couldn't be renamed without causing issues for this list, not sure why that was
            // done in the first place.
            .find((key) => {
            const iter = extensions[key];
            return ((ext.modId !== undefined && iter.modId === ext.modId) ||
                (ext.id !== undefined && (iter.id || key) === ext.id));
        }) !== undefined);
    }
    renderListEntry = (ext, idx) => {
        const { t } = this.props;
        const { installing, selected } = this.state;
        const classes = ["extension-item"];
        if (selectorMatch(ext, selected)) {
            classes.push("selected");
        }
        const installed = this.isInstalled(ext);
        const incompatible = !this.isCompatible(ext);
        const action = installing.indexOf(ext.name) !== -1 ? (React.createElement(Spinner, null)) : installed ? (React.createElement("div", null, t("Installed"))) : incompatible ? (React.createElement("div", null, t("Incompatible"))) : (React.createElement("a", { className: "extension-subscribe", "data-modid": ext.modId, "data-github": ext.github, "data-githubrawpath": ext.githubRawPath, onClick: this.install }, t("Install")));
        return (React.createElement(ListGroupItem, { className: classes.join(" "), key: makeSelectorId(ext), "data-modid": ext.modId, "data-github": ext.github, "data-githubrawpath": ext.githubRawPath, onClick: this.select, disabled: installed || incompatible },
            React.createElement("div", { className: "extension-header" },
                React.createElement("div", { className: "extension-title" },
                    React.createElement("span", { className: "extension-name" }, ext.name),
                    React.createElement("span", { className: "extension-version" }, ext.version)),
                React.createElement("div", { className: "extension-stats" },
                    ext.downloads !== undefined ? (React.createElement("div", { className: "extension-downloads" },
                        React.createElement(Icon, { name: "download" }),
                        " ",
                        largeNumToString(ext.downloads))) : null,
                    ext.endorsements !== undefined ? (React.createElement("div", { className: "extension-endorsements" },
                        React.createElement(Icon, { name: "endorse-yes" }),
                        " ",
                        largeNumToString(ext.endorsements))) : null)),
            React.createElement("div", { className: "extension-description" }, ext.description.short),
            React.createElement("div", { className: "extension-footer" },
                React.createElement("div", { className: "extension-author" }, ext.author),
                action)));
    };
    renderDescription = (ext) => {
        const { t } = this.props;
        const { installing } = this.state;
        if (ext === undefined) {
            return null;
        }
        const installed = this.isInstalled(ext);
        const openInBrowser = (React.createElement("a", { className: "extension-browse", "data-modid": ext.modId, "data-github": ext.github, "data-githubrawpath": ext.githubRawPath, onClick: this.openPage },
            React.createElement(Icon, { name: "open-in-browser" }),
            t("Open in Browser")));
        const action = installing.indexOf(ext.name) !== -1 ? (React.createElement(Spinner, null)) : installed ? (React.createElement("div", null, t("Installed"))) : !this.isCompatible(ext) ? (React.createElement("div", null, t("Incompatible"))) : (React.createElement("a", { className: "extension-subscribe", "data-modid": ext.modId, "data-github": ext.github, "data-githubrawpath": ext.githubRawPath, onClick: this.install }, t("Install")));
        return (React.createElement(FlexLayout, { type: "column" },
            React.createElement(FlexLayout.Fixed, null,
                React.createElement(FlexLayout, { type: "row", className: "description-header", fill: false },
                    React.createElement(FlexLayout.Fixed, null,
                        React.createElement("div", { className: "description-image-container" },
                            React.createElement(ZoomableImage, { className: "extension-picture", url: ext.image }))),
                    React.createElement(FlexLayout.Flex, null,
                        React.createElement(FlexLayout, { type: "column", className: "description-header-content" },
                            React.createElement("div", { className: "description-title" },
                                React.createElement("span", { className: "description-name" }, ext.name),
                                React.createElement("span", { className: "description-author" },
                                    t("by"),
                                    " ",
                                    ext.author)),
                            React.createElement("div", { className: "description-short" }, ext.description.short),
                            React.createElement("div", { className: "description-stats" },
                                ext.downloads !== undefined ? (React.createElement("div", { className: "extension-downloads" },
                                    React.createElement(Icon, { name: "download" }),
                                    " ",
                                    ext.downloads)) : null,
                                ext.endorsements !== undefined ? (React.createElement("div", { className: "extension-endorsements" },
                                    React.createElement(Icon, { name: "endorse-yes" }),
                                    " ",
                                    ext.endorsements)) : null),
                            React.createElement("div", { className: "description-actions" },
                                action,
                                " ",
                                openInBrowser))))),
            React.createElement(FlexLayout.Flex, null,
                React.createElement("div", { className: "description-text" }, bbcode(ext.description.long)))));
    };
    install = (evt) => {
        const { availableExtensions } = this.props;
        const modIdStr = evt.currentTarget.getAttribute("data-modid");
        const modId = modIdStr !== null ? parseInt(modIdStr, 10) : undefined;
        const github = evt.currentTarget.getAttribute("data-github");
        const githubRawPath = evt.currentTarget.getAttribute("data-githubrawpath");
        const ext = availableExtensions.find((iter) => selectorMatch(iter, { modId, github, githubRawPath }));
        this.nextState.installing.push(ext.name);
        downloadAndInstallExtension(this.context.api, ext)
            .then((success) => {
            if (success) {
                this.props.updateExtensions();
            }
        })
            .catch((err) => {
            this.context.api.showErrorNotification("Failed to install extension", err);
        })
            .finally(() => {
            this.nextState.installing = this.state.installing.filter((name) => name !== ext.name);
        });
    };
    select = (evt) => {
        const modIdStr = evt.currentTarget.getAttribute("data-modid");
        const modId = modIdStr !== null ? parseInt(modIdStr, 10) : undefined;
        const github = evt.currentTarget.getAttribute("data-github");
        const githubRawPath = evt.currentTarget.getAttribute("data-githubrawpath");
        this.nextState.selected = { modId, github, githubRawPath };
    };
    openPage = (evt) => {
        const { availableExtensions } = this.props;
        const modIdStr = evt.currentTarget.getAttribute("data-modid");
        const modId = modIdStr !== null ? parseInt(modIdStr, 10) : undefined;
        const github = evt.currentTarget.getAttribute("data-github");
        const githubRawPath = evt.currentTarget.getAttribute("data-githubrawpath");
        const ext = availableExtensions.find((iter) => selectorMatch(iter, { modId, github, githubRawPath }));
        if (ext.modId !== undefined) {
            opn(NEXUS_MODS_URL + ext.modId).catch(() => null);
        }
        else if (github !== undefined) {
            opn(GITHUB_BASE_URL + "/" + github).catch(() => null);
        }
    };
}
function mapStateToProps(state) {
    return {
        availableExtensions: state.session.extensions.available,
        extensions: state.session.extensions.installed,
        updateTime: state.session.extensions.updateTime,
        language: state.settings.interface.language,
    };
}
export default translate(["common"])(connect(mapStateToProps)(BrowseExtensions));
